
import ImageCustom from '@/components/Image'
import { LinkType } from '@/libs/types'
import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'

interface LinkedProps {
    linked: LinkType
    className?: string
    locale: string
    clicker?: () => void
}

const Linked: React.FunctionComponent<LinkedProps> = ({
    locale,
    linked,
    className,
    clicker,
    children
}) => {

    return (
        <Link
            onClick={!clicker ? undefined : clicker}
            className={clsx(className, "d-block", "text-decoration-none", linked.button ? "btn btn-primary text-light" : "")}
            href={linked.target === "_self" ? `/${locale}/${linked.href.split(",").join("/")}/` : linked.href}
            target='_blank'
            passHref
        >
            {linked?.icon && (
                <ImageCustom src={linked?.icon} width={24} height={24} aspectratio="1:1" alt={linked.text} />
            )}
            {!linked.icon && linked.text}
            {!!children ? children : null}
        </Link>
    )
}
export default Linked